import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';

export const catActualite = createAction(types.CAT_ACTUALITE, (catActualite: any[]) => ({
    payload: catActualite,
}));
